import * as React from 'react';
import { compose, withProps } from 'recompose';
import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { Prompt } from 'react-router';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { get } from 'lodash';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Card } from 'material-ui/Card';

import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';

import { Tabs } from '@components/tabs';

import { WantedPersonsFormPerson } from '@modules/wantedPersons/WantedPersonsFormPerson';
import { WantedPersonsFormSearch } from '@modules/wantedPersons/WantedPersonsFormSearch';

import { getWantedPerson, defaultWantedPerson } from '@modules/wantedPersons/_wantedPersonsActions';

import * as T from '@modules/wantedPersons/_wantedPersonsTypes';
import { getActualDate } from '@utils/utils';

export const enhance = compose<T.WantedPersonsFormProps, T.Outter>(
  entityDetailEnhancer<T.WantedPersonEnhancerProps<T.WantedPerson> & Partial<T.WantedPerson>, T.WantedPerson>({
    getEntity: getWantedPerson,
    defaultEntity: defaultWantedPerson
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Hledaní lidé', to: '/wanted/persons' },
    { label: get(entity, 'person.fullName', 'Nová osoba') }
  ]),
  withProps<{}, T.WantedPersonProps>(({ entity }) => ({
    initialValues: {
      reportedDate: getActualDate(),
      found: false,
      ...entity
    }
  })),
  reduxForm({}),
  connect(state => ({
    address: formValueSelector('module-person')(state, 'person.address')
  }))
);

export const View: React.SFC<T.Outter & T.WantedPersonsFormProps> = ({
  handleSubmit,
  closeItem,
  dirty,
  submitSucceeded,
  submitting
}) => (
  <div>
    <Prompt when={dirty && !submitSucceeded && !submitting} message="Vaše změny nebyly uloženy, přesto odejít?" />
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        <Tabs
          items={[
            {
              label: 'Osoba',
              style: { minWidth: 150 },
              content: <WantedPersonsFormPerson form={'module-person'} />
            },
            { label: 'Pátrání', style: { minWidth: 150 }, content: <WantedPersonsFormSearch /> }
          ]}
        />

        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);

export const WantedPersonsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/wantedPersons/WantedPersonsForm.tsx